export function loadingCategory(plan) {
  const first = plan?.pallets?.[0];
  if (first?.loading_category) return first.loading_category;
  const id = String(plan?.pallet_type_id || "");
  if (!id.startsWith("loading:")) return "pallet";
  return id.split(":")[1] || "pallet";
}

export function loadingUnitLabel(plan) {
  const first = plan?.pallets?.[0];
  if (first?.unit_label) return first.unit_label;
  return {
    container: "Konteyner",
    trailer: "Tır",
    truck: "Kamyon",
    pallet: "Palet",
  }[loadingCategory(plan)] || "Yükleme Birimi";
}

export function loadingUnitPlural(plan) {
  return {
    container: "Konteynerler",
    trailer: "Tırlar",
    truck: "Kamyonlar",
    pallet: "Paletler",
  }[loadingCategory(plan)] || "Yükleme Birimleri";
}

export function loadingUnitName(plan, unit, index = 0) {
  const label = unit?.unit_label || loadingUnitLabel(plan);
  const no = unit?.loading_unit_no || unit?.pallet_no || index + 1;
  return `${label} ${no}`;
}

export function isLargeLoadingPlan(plan) {
  return loadingCategory(plan) !== "pallet";
}
